import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BuildInfoModal } from './BuildInfoModal';
import { RTDBConsoleURL } from '@admin/firebase';
import { RTDBPath } from 'balus-common';
import { MenuLink } from '../UserPopupMenu/MenuLink';

export const AdminMenu: React.FC<unknown> = () => {
  const { t } = useTranslation();
  const [showBuildInfoModal, setShowBuildInfoModal] = useState<boolean>(false);

  return (
    <div className="border-y border-gray-500">
      <MenuLink href={RTDBConsoleURL.build(RTDBPath.App.appPath())} label="Firebase Console" />
      <MenuLink href="/admin/console" label={t('framework.topNav.adminConsole')} />

      <button
        onClick={() => setShowBuildInfoModal(true)}
        className="block w-full px-4 py-2 text-left text-gray-800 hover:bg-gray-200"
      >
        {t('framework.topNav.showBuildInfo')}
      </button>
      {showBuildInfoModal && <BuildInfoModal onClose={() => setShowBuildInfoModal(false)} />}
    </div>
  );
};
